import * as React from 'react'
import StoryblokService from 'utils/storyblok-service'
import MaintenanceComponent from './Maintenance'

export const transformProps = (propsArg) => ({
  ...propsArg,
  content: StoryblokService?.client?.richTextResolver?.render(propsArg.content),
})
const Maintenance = (props) => <MaintenanceComponent {...transformProps(props)} />

export default Maintenance
